import React from 'react';

export const purchasePackagesReportListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام و نام خانوادگی',
    dataIndex: 'fullName',
    name: 'fullName',
    isSortable: false,
  },
  {
    title: 'تاریخ خرید بسته',
    dataIndex: 'date',
    name: 'date',
    isSortable: true,
  },
  {
    title: 'نام بسته',
    dataIndex: 'packageName',
    name: 'packageName',
    isSortable: false,
  },
  {
    title: 'مبلغ پرداخت شده',
    dataIndex: 'amount',
    name: 'amount',
    isSortable: false,
    render: amount => (
      <div className={`direction-ltr`}>{Number(amount).toLocaleString()}</div>
    ),
  },
  {
    title: 'تعداد آرسی بسته',
    dataIndex: 'boughtRsee',
    name: 'boughtRsee',
    isSortable: false,
  },
];